import { render } from "./ProFeatures.vue?vue&type=template&id=5c709e73&scoped=true"
import script from "./ProFeatures.vue?vue&type=script&lang=js"
export * from "./ProFeatures.vue?vue&type=script&lang=js"

import "./ProFeatures.vue?vue&type=style&index=0&id=5c709e73&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c709e73"]])

export default __exports__